document.addEventListener('DOMContentLoaded',function(){

  // Home page In The News section
    var newssection = document.querySelector(".news-deatils-wrapper");
    var swiper = new Swiper('.news-deatils-wrapper', {
        loop: false, 
        slidesPerView: 4, 
        spaceBetween: 10, 
        autoplay:false,
        pagination: {
            el: ".deatils-wrapper .swiper-pagination",
           clickable: true,
          },
    });

    var swiper = new Swiper('.hero-slider', {
        loop: false, 
        slidesPerView: 1, 
        spaceBetween: 0, 
        autoplay:false
    });

  // Home page Tab Featured section 
  
    const tabCollection = document.querySelector(".tab-featured-collection");
    if (tabCollection) {
      const tabTitles = tabCollection.querySelectorAll(".tabheader li");
      const tabContentBlocks = tabCollection.querySelectorAll(".tabinfo_block");
    
      tabTitles.forEach(tabTitle => {
        tabTitle.addEventListener("click", () => {
          const targetId = tabTitle.getAttribute("data-title");
          tabTitles.forEach((title) => title.classList.remove("active"));
          tabTitle.classList.add("active");
  
          tabContentBlocks.forEach(tabContentBlock => {
            var dataTabContent = tabContentBlock.getAttribute("data-content");
            tabContentBlock.classList.toggle("active", dataTabContent === targetId);
            tabContentBlock.classList.toggle("hidden", dataTabContent !== targetId);
          });
        });
      });
    }

 // Home page Featured collection slider and featured tab section
  const sliders = document.querySelectorAll('.productlistslider');
  sliders.forEach((slider) => {
    var section = slider.closest("section"); // Find the closest section
    var pdpsliders = section.querySelectorAll(".swiper"); // Get all Swipers inside that section
  
    pdpsliders.forEach((pdpslider) => { // Loop through each swiper inside the section
      var sliderArrow = pdpslider.closest('.productslider-arrow');
      new Swiper(pdpslider, {
        loop: false,
        slidesPerView: 4,
        spaceBetween: 10,
        autoplay: false,
        navigation: {
          nextEl: sliderArrow.querySelector('.rightarrow-sliderbutton'),
          prevEl: sliderArrow.querySelector('.leftarrow-sliderbutton'), 
        },
        pagination: {
          el: pdpslider.closest('.productlistslider').querySelector('.swiper-pagination'), // Pagination specific to this slider
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 2.3,
            spaceBetween: 12
          },
          480: {
            slidesPerView: 3.3,
            spaceBetween: 20
          },
          1000: {
            slidesPerView: 4.2,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 5.2,
            spaceBetween: 24
          },
        },
      });
    });
  });

  // Homepage BackToTop Button
    const backToTopButton = document.querySelector('.backtotop_mobile_button');
    backToTopButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // This makes the scroll smooth
      });
    });

  // Home page footer mobile accordian section
    var footerBlocks = document.querySelectorAll(".footer-col");
    if (footerBlocks.length) {
      footerBlocks.forEach((footerBlock) => {
        var blockTitle = footerBlock.querySelector(".footermenu_title");
        if (blockTitle) {
          blockTitle.addEventListener("click", function () {
            footerBlocks.forEach((block) => {
              var title = block.querySelector(".footermenu_title");
              if(title){
                var sibling = title.nextElementSibling;
                if (title !== blockTitle) {
                  title.classList.remove("active");
                  sibling.classList.remove("active");
                }
              }
            });
    
            blockTitle.classList.toggle("active");
            var nextElement = blockTitle.nextElementSibling;
            if (nextElement) {
              nextElement.classList.toggle("active");
            }
          });
        }
      });
    }

  // Home page categories button click open drawer
    var categoriesButton = document.querySelector(".mobilesticky-bar-wrap .open_mobilemenu");
    if(categoriesButton){
      categoriesButton.addEventListener('click',function(e){
        e.preventDefault();
        var mobileDrawerButton = document.querySelector(".header__icon-list button[aria-controls='header-sidebar-menu']");
        if(mobileDrawerButton){
          mobileDrawerButton.click();
        }
      });
    }
  
  // Mobile menu drawer close
    const closeBtn = document.querySelector(".customer-details-wrapper .drawerclosebutton");
    if(closeBtn){
      closeBtn.addEventListener('click',function(){
        document.querySelector(".header__icon-list button[aria-controls='header-sidebar-menu']").click();
      });
    }
   
  // Mobile menu drawer header app block
    var appBlockCloseBtn = document.querySelector(".mobileappbutton-block");
    if(appBlockCloseBtn){
      appBlockCloseBtn.addEventListener('click',function(){
        var drawerHeader = document.querySelector(".mobile_drawerheader");
        if(drawerHeader){
          drawerHeader.classList.add('hidden');
        }
      });
    }
  
  //Mobile Menu Drawer submenu open 
   var submenuElems = document.querySelectorAll(".mainstap-list.withsubmenu");
    if (submenuElems.length) {
      submenuElems.forEach(function (submenuElem) {
        var submenuButtons = submenuElem.querySelectorAll(".submenuopen-button");
        if (submenuButtons.length) {
          submenuButtons.forEach(function (submenuDrawerBtn) {
            submenuDrawerBtn.addEventListener('click', function () {
             submenuDrawerBtn.classList.toggle("active");
    
              var mainMenu = submenuDrawerBtn.closest(".withsubmenu");
              var submenu = submenuDrawerBtn.closest("li").querySelector(".menu");
              if (submenu) {
                submenu.classList.toggle('active');
              }
            });
          });
        }
      });
    }
   
  const blocks = document.querySelectorAll(".collction_block");
  const showBlockBtn = document.querySelector(".showBlock");
  if(blocks && showBlockBtn){
    // Initial setup: Ensure all elements are visible on load
    blocks.forEach((block) => block.classList.remove("hidden"));
    showBlockBtn.classList.add("seeless");

    showBlockBtn.addEventListener("click", function(){
      if (showBlockBtn.classList.contains("seeless")) {
        // Hide after 9 blocks
        blocks.forEach((block, index) => {
          block.classList.toggle("hidden", index >= 9);
        });
        showBlockBtn.classList.remove("seeless");
        showBlockBtn.classList.add("seemore");
      } else {
        // Show all blocks
        blocks.forEach((block) => block.classList.remove("hidden"));
        showBlockBtn.classList.remove("seemore");
        showBlockBtn.classList.add("seeless");
      }
    });    
  }  

  // Product page media key highlights
  var key_highlight_button = document.querySelector(".main-productimage-slider .pdp_highlights_button");
  if(key_highlight_button){
    var highlightContent = document.querySelector(".pdp_highlights_contnet");
    if(highlightContent){
      key_highlight_button.addEventListener('click',function(){
        key_highlight_button.classList.toggle('active');
        highlightContent.classList.toggle('active');
      });
    }
  }

  // Product page sticky cart btn
  var cartBtn = document.querySelector(".pdp-stickybar .cart-btn");
  console.log("cart BTN",cartBtn);
  if(cartBtn){
    // cartBtn.addEventListener('click',function(){
    //   var addToCartBTn = document.querySelector(".product-info__buy-buttons button");
    //   console.log("addToCartBTn",addToCartBTn);
    //   if(addToCartBTn){
    //     addToCartBTn.click();
    //   }
    // });
  }

  //product page - on custom button click theme's deafult button click
  // var customBuyButton =  document.querySelector(".quantity_buyButton_wrapper .buyButton button");
  // console.log("customBuyButton",customBuyButton);
  // if(customBuyButton){
  //   customBuyButton.addEventListener('click',function(){
  //     console.log("custom button clicked...");
  //     document.querySelector(".product-info__buy-buttons button").click();
  //   });
  // }
  
  // Product page LBS AND KGS tab --- code in theme.js file
  
  // Product page - banefits wrapper swiper
  var banefitsWrapper = document.querySelector(".product-info__benefits-details.swiper");
  if(banefitsWrapper){
    new Swiper(banefitsWrapper, {
      loop: false,
      slidesPerView: 3.2,
      slideToClickedSlide: true,
      autoplay: false,
      navigation: {
        nextEl: '.benefit-next', 
        prevEl: '.benefit-prev', 
      },
      breakpoints: {       
        700: {
          slidesPerView: 4.5,
        }
      }
    });
  }

  
  // Product page details collapsible Blocks
  var collapsibleTabs = document.querySelectorAll(".product-info-faqblock .tab_wrapper");
  // console.log("collapsibleTabs",collapsibleTabs);
  if (collapsibleTabs) {
    collapsibleTabs.forEach((collapsibleTab) => {
      var tabTitle = collapsibleTab.querySelector(".tab-title");
      var tabContentBlock = collapsibleTab.querySelector(".tab-block");
  
      tabTitle.addEventListener("click", function () {
        // Check if the clicked tab is already active
        var isActive = tabTitle.classList.contains("active");
  
        // Loop through all tab wrappers
        collapsibleTabs.forEach((elem) => {
          var otherTabTitle = elem.querySelector(".tab-title");
          var otherTabContent = elem.querySelector(".tab-block");
  
          if (elem === collapsibleTab) {
            // Toggle the active class and hidden class for the clicked tab
            if (isActive) {
              otherTabTitle.classList.remove("active");
              otherTabContent.classList.add("hidden");
            } else {
              otherTabTitle.classList.add("active");
              otherTabContent.classList.remove("hidden");
            }
          } else {
            // Remove 'active' from other tabs' titles and hide their content
            otherTabTitle.classList.remove("active");
            otherTabContent.classList.add("hidden");
          }
        });
      });
    });
  }

  
  //Product page offer section slider
  var offersection =  document.querySelector(".offerdetail_slider.swiper");
  if(offersection){
    new Swiper(offersection,{
      loop: false,
      spaceBetween:10,
      slidesPerView: 1.3,
      slideToClickedSlide: true,
      autoplay: false,
      breakpoints: {       
        700: {
          slidesPerView: 2.3,
        }
      }
    });
  }

  //Product page offercode to copy
  var offercodeButtons = document.querySelectorAll(".offer_code");
  if(offercodeButtons.length){
      offercodeButtons.forEach(function(button){
        button.addEventListener('click', function() {
          const textToCopy = button.textContent;
         
          const tempTextarea = document.createElement('textarea');
          tempTextarea.value = textToCopy;
       
          document.body.appendChild(tempTextarea);
          tempTextarea.select();
          tempTextarea.setSelectionRange(0, 99999); 
          document.execCommand('copy');
          document.body.removeChild(tempTextarea);
  
          button.classList.add('active');
          setTimeout(function() {
            button.classList.remove('active');
          }, 2000); 
        });
      });
    }

  //Product page Details image slider
    const productDetailSliders = document.querySelectorAll('.productDetailsslider');
      productDetailSliders.forEach((productDetailSlider) => {
          new Swiper(productDetailSlider, {
             loop: false,
              slidesPerView: 1,
              slideToClickedSlide: true,
              autoplay: false,
              pagination: {
                  el: ".productDetailsslider .swiper-pagination",
                  clickable: true,
              },
              breakpoints: {       
                700: {
                  slidesPerView: 2.3,
                  spaceBetween:20
                }
              },
          });
      });

  
  // Collection page banner swiper section
    var collectionBanner = document.querySelector(".collection-banner-section.swiper");
    if (collectionBanner) {
      new Swiper(collectionBanner, {
        loop: true,
        spaceBetween:10,
        slidesPerView: 1,
        slideToClickedSlide: true,
        autoplay: false,
        pagination: {
          el: ".collection-banner-section .swiper-pagination",
          clickable: true,
        },
      });
    }

  //Collection page soryBy popup
    var sortByBtn = document.querySelector(".mobile-sortby-button");
    var sortByPopup = document.querySelector(".mobile-sortby-popup");
    var mobileOverlay = document.querySelector(".mobile-sortby-overlay");
    if(sortByBtn){
      sortByBtn.addEventListener("click",function(){
        document.body.classList.add('sortby-popup-active');        
        sortByPopup.classList.add("active");
        mobileOverlay.classList.add("active");
      });
    }

    const closeButton = document.querySelector('.sortby-popupclose-button');
    const overlay = document.querySelector('.mobile-sortby-overlay');
    
    const handleClick = () => {
      sortByPopup.classList.remove("active");
      mobileOverlay.classList.remove('active');
      document.body.classList.remove('sortby-popup-active');
    };
    
    if(closeButton) closeButton.addEventListener('click', handleClick);
    if(overlay) overlay.addEventListener('click', handleClick);


  // Sticky bar show and hide on bas eof main add to cart
    let lastScrollTop = 0;
    const buyButtons = document.querySelector('.quantity_buyButton_wrapper');
    const stickyBar = document.querySelector('.pdp-stickybar');
    
    if(buyButtons && stickyBar){
      function isElementOutOfViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.bottom <= 0; // Element is completely out of the viewport (above the screen)
      }
      
      function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top >= 0 && rect.bottom <= window.innerHeight; // Element is fully within the viewport
      }
      
      window.addEventListener('scroll', function () {
        let scrollTop = window.scrollY;
      
        if (scrollTop > lastScrollTop) {
          if (isElementOutOfViewport(buyButtons)) {
            stickyBar.classList.add('active'); // Add active class when buy buttons leave the viewport
          }
        } else {
          if (isElementInViewport(buyButtons)) {
            stickyBar.classList.remove('active'); // Remove active class when buy buttons re-enter the viewport
          }
        }
    
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      });
    }

  // cart drawer - cart recommendation slider
  // code added in theme.js -commented as "cart drawer - cart recommendation slider"
  

  // cart drawer addToCart button functionality
  // var customAddButtons = document.querySelectorAll(".drawercart-button");
  // if(customAddButtons.length){
  //   customAddButtons.forEach(function(customAdd){
  //     customAdd.addEventListener('click',function(){
  //       console.log("custom.js quick view btn clicked....");
  //       var productCard = customAdd.closest(".product-card-col");
  //       var quickViewBtn = productCard.querySelector(".quick-view-btn button");
  //       console.log("quickViewBtn",quickViewBtn);
  //       quickViewBtn.click();
  //     });
  //   });
  // }
 quickAdd();
clearAllCart();
 // share button - collection page & product page
  var shareButton = document.querySelector(".shareButton");
  // console.log("shareButton",shareButton);
  if(shareButton){
    shareButton.addEventListener('click', () => {
      if (navigator.share) {
        // If the browser supports the Web Share API
        navigator.share({
          title: 'Check this out!',
          text: 'Here is something you might like!',
          url: window.location.href
        }).catch(function(error) {
          console.error(error); // Catch any errors
        });
      } else {
        var shareUrl = encodeURIComponent(window.location.href);
        var whatsappLink = 'https://wa.me/?text=' + shareUrl;
        var telegramLink = 'https://t.me/share/url?url=' + shareUrl;
      
        var fallbackHtml = '<div>' +
          '<a href="' + whatsappLink + '" target="_blank">Share on WhatsApp</a>' +
          '<a href="' + telegramLink + '" target="_blank">Share on Telegram</a>' +
          '</div>';
        document.body.insertAdjacentHTML('beforeend', fallbackHtml);
      }

    });
    if (window.innerWidth > 700) {
     shareButton.addEventListener("click", function () {
          const url = window.location.href; // Get the current URL
          navigator.clipboard.writeText(url).then(() => {
              console.log("URL copied to clipboard!");
              // alert("URL copied to clipboard!");
          }).catch(err => {
              console.error("Failed to copy URL: ", err);
          });
          shareButton.classList.add('active');
          setTimeout(function() {
            shareButton.classList.remove('active');
          }, 2000); 
      });
    }
  }

  // //  If free gift manually removed than again not added
  // document.addEventListener('click', function (event) {
  //   const button = event.target.closest('.quantity-selector__button');
  
  //   if (button && button.closest('.custom-var-id.free')) {
  //     const productElement = button.closest('.custom-var-id');
  //     const variantId = productElement.getAttribute('var-id');
  
  //     console.log(`Manually removing product with variant ID: ${variantId}`);
  
  //     fetch('/cart/change.js', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ id: variantId, quantity: 0 })
  //     })
  //       .then(response => response.json())
  //       .then(() => {
  //         document.dispatchEvent(new CustomEvent("cart:refresh"));
  //         // Record that the user manually removed this free product
  //         const removeProducts = JSON.parse(localStorage.getItem('removeProducts')) || [];
  //         removeProducts.push({ id: variantId, quantity: 1 });
  //         localStorage.setItem('removeProducts', JSON.stringify(removeProducts));
  
  //         console.log('Removed product stored in localStorage:', removeProducts);
  //       })
  //       .catch(error => console.error('Error removing product:', error));
  //   }
  // });



  // Collection page mobile filter functionality
    var tabTitles = document.querySelectorAll("facet-drawer .tab_title");
    if (tabTitles) {
      const accordions = document.querySelectorAll("facet-drawer .filter-accordian");
      accordions.forEach((accordion, index) => {
        if (index === 0) {
            accordion.classList.add("active");
        }
      });
      
      tabTitles.forEach(function(tabTitle){
        tabTitle.addEventListener('click', function() {
          tabTitles.forEach(tabTitle => tabTitle.classList.remove("active"));
          tabTitle.classList.add("active");
          var tabLabel = tabTitle.getAttribute("data-label");
          accordions.forEach(accordion => accordion.classList.remove("active"));
          
          var dataAccordian = document.querySelector("facet-drawer .filter-accordian[data-content='" + tabLabel + "']");
          dataAccordian.classList.add('active');
          
          // Check if the dataAccordian has the open attribute
          if (!(dataAccordian.hasAttribute('open'))) {
            dataAccordian.querySelector("summary").click();
          }
        });
      });
    
      // Trigger the first tab click
      if(tabTitles[0]){
         tabTitles[0].click();
      }
    }
  
  // Disabled size variant ion base selected flavour on Product page
  var selectedOption = document.querySelector(".variant-picker__option.flavour");
  if(selectedOption){
    var checkedInput = selectedOption.querySelector("input:checked");
    var label = checkedInput.nextElementSibling;
    var option2 = label.getAttribute("data-value");
    var variantJson = JSON.parse(document.querySelector("variant-picker").getAttribute("data-variant"));
      if (Array.isArray(variantJson)) {
        let matchingVariants = variantJson.filter(variant => variant.option2 === option2);
        let option1Values = matchingVariants.map(variant => variant.option1);
                      
        // Select all labels with a data-value attribute
        document.querySelectorAll('.variant-picker__option.size .block-swatch').forEach(label => {
          label.classList.remove('is-disabled');
          const value = label.getAttribute('data-value');
          console.log("option1Values",option1Values, value, matchingVariants, option2);          
          // If the value is NOT in filteredValues, add 'disabled' class
            if (!option1Values.includes(value)) {
              label.classList.add('is-disabled');
            }
        });
      } else {
        console.error("variantJson is not an array");
      }
  }
  
  // Account page reorder functionality
    var reorderButtons = document.querySelectorAll(".order-grid-list .vieworder-detailbutton");
    if(reorderButtons.length){
      reorderButtons.forEach((reorderButton)=>{
        reorderButton.addEventListener('click',function(){
          var orderElem = reorderButton.closest(".order-grid-item");
          var orderId = orderElem.getAttribute("data-order-id");
          let itemIds = this.getAttribute("data-variants").split(",").filter(id => id);
          console.log("Order Item IDs:", itemIds);
          
          if (itemIds.length > 0) {
            addItemsToCart(itemIds);
          } else {
            console.warn("No variant IDs found for reorder.");
          }
        });
      });
    }
  
    function addItemsToCart(variantIds) {
      let items = variantIds.map(id => ({ id: id, quantity: 1 }));
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      })
      .then(response => response.json())
      .then(data => {
        console.log("Added to cart:", data);
        sessionStorage.setItem("openCartDrawer", "true");

        // Redirect to the home page
        window.location.href = "/";
      })
      .catch(error => console.error("Error adding items:", error));
    }

    if (sessionStorage.getItem("openCartDrawer") === "true") {
      sessionStorage.removeItem("openCartDrawer"); 
  
      setTimeout(() => {
        let cartButton = document.querySelector(".header__icon-list [aria-controls='cart-drawer']"); 
        if (cartButton) {
          cartButton.click();
        } else {
          console.warn("Cart drawer button not found!");
        }
      }, 200); 
    }
});

document.addEventListener("DOMContentLoaded", function() {
  window.addEventListener("scroll", function() {
    var height = window.innerHeight * 0.3;
    var scroll = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scroll > height) {
      document.body.classList.add("page-scroll");
    } else {
      document.body.classList.remove("page-scroll");
    }
  });
});


// **** functions available in theme.js file ****//
function freeProducts(total_price_1) {
  console.log("total_price_1",total_price_1);
  if(total_price_1 == undefined){
    var totalPrice = Number(
      document.querySelector('.col.custom-free-pdp')?.getAttribute('cart-price')
    );
  }else{
    var totalPrice = total_price_1;
  }
  var checkoutBtn = document.querySelector(".gokwik-checkout");
  var freepdpBlock = document.querySelector(".cartfreegift-box-wrap");

  const freeProductsList = document.querySelectorAll('.col.custom-free-pdp');
  const removedProducts = JSON.parse(localStorage.getItem('removeProducts')) || [];
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      const addableProducts = [];
      const updateableProducts = [];
      const removableProducts = [];

      freeProductsList.forEach(product => {
        const freeThresholdPrice = Number(product.getAttribute('freethresold-price'));
        const variantId = product.getAttribute('freethresold-pId');

        document.querySelectorAll('.custom-var-id[var-id="' + variantId + '"]').forEach(el => {
          el.classList.add('free');
        });

        const cartItem = cartData.items.find(
          item => String(item.variant_id) === variantId
        );

        const isManuallyRemoved = removedProducts.some(
          item => String(item.id) === variantId
        );

        if (totalPrice >= freeThresholdPrice) {
          if (!isManuallyRemoved) {
            if (!cartItem) {
              addableProducts.push({ 
                id: variantId, 
                quantity: 1,
                properties: { _giftProduct: 'Gift Product' }
              });
            } else {
              if (cartItem.quantity !== 1) {
                updateableProducts.push({ id: variantId, quantity: 1 });
              }
            }
          }
        } else {
          if (cartItem) {
            removableProducts.push({ id: variantId, quantity: 0 });
          }
        }
      });

              

      if (addableProducts.length > 0) {
        if(checkoutBtn) checkoutBtn.classList.add('loading');
        if(freepdpBlock) freepdpBlock.classList.add('loading');
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: addableProducts })
        })
          .then(response => response.json())
          .then(() => {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          })
          .catch(error => console.error('Error adding products:', error))
          .finally(() => {
            // Remove 'loading' class after process is done
            console.log("class have to remove");
            if(checkoutBtn) checkoutBtn.classList.remove('loading');
            if(freepdpBlock) freepdpBlock.classList.remove('loading');
          });
      }

      if (updateableProducts.length > 0) {
         if(checkoutBtn) checkoutBtn.classList.add('loading');
        if(freepdpBlock) freepdpBlock.classList.add('loading');
        
        const updates = Object.fromEntries(
          updateableProducts.map(item => [item.id, item.quantity])
        );
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        })
          .then(response => response.json())
          .then(() => {
            document.dispatchEvent(new CustomEvent("cart:refresh")); 
          })
          .catch(error => console.error('Error updating products:', error))
          .finally(() => {
            // Remove 'loading' class after process is done
            console.log("class have to remove");
            if(checkoutBtn) checkoutBtn.classList.remove('loading');
            if(freepdpBlock) freepdpBlock.classList.remove('loading');
          });
      }

      // Process removals for free products when the cart doesn't qualify
      if (removableProducts.length > 0) {
         if(checkoutBtn) checkoutBtn.classList.add('loading');
        if(freepdpBlock) freepdpBlock.classList.add('loading');
        
        const updates = Object.fromEntries(
          removableProducts.map(item => [item.id, 0])
        );
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        })
          .then(response => response.json())
          .then(() => {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          })
          .catch(error => console.error('Error removing products:', error))
          .finally(() => {
            // Remove 'loading' class after process is done
             console.log("class have to remove");
            if(checkoutBtn) checkoutBtn.classList.remove('loading');
            if(freepdpBlock) freepdpBlock.classList.remove('loading');
          });
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

function replacefreeProducts(totalPrice_1) {
  let totalPrice;
  if (totalPrice_1 === undefined) {
    totalPrice = Number(document.querySelector('.col.custom-free-pdp')?.getAttribute('cart-price'));
  } else {
    totalPrice = totalPrice_1;
  }

  const freeProductsList = Array.from(document.querySelectorAll('.col.custom-free-pdp'));
  freeProductsList.sort((a, b) =>
    Number(a.getAttribute('freethresold-price')) - Number(b.getAttribute('freethresold-price'))
  );

  console.log('totalPrice', totalPrice);

  let eligibleGift = null;
  freeProductsList.forEach(product => {
    const threshold = Number(product.getAttribute('freethresold-price'));
    if (totalPrice >= threshold) {
      eligibleGift = product;
    }
  });

  const freeGiftVariantIds = freeProductsList.map(product =>
    product.getAttribute('freethresold-pId')
  );

  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      let cartFreeGifts = cartData.items.filter(item =>
        freeGiftVariantIds.includes(String(item.variant_id))
      );

      console.log('cartFreeGifts', cartFreeGifts);

      const updates = {};
      cartFreeGifts.forEach(item => {
        if (!eligibleGift || String(item.variant_id) !== eligibleGift.getAttribute('freethresold-pId')) {
          updates[item.variant_id] = 0; // Remove old non-eligible free gifts
        }
      });

      const eligibleVariantId = eligibleGift ? eligibleGift.getAttribute('freethresold-pId') : null;
      const isAlreadyInCart = cartFreeGifts.some(item => String(item.variant_id) === eligibleVariantId);

      if (Object.keys(updates).length > 0) {
        console.log("Removing old free products...");
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        })
          .then(response => response.json())
          .then(() => {
            if (eligibleGift && !isAlreadyInCart) {
                addEligibleGift(eligibleGift);
             
            } else {
              console.log("No new free product to add or already in cart.");
              document.dispatchEvent(new CustomEvent("cart:refresh"));
            }
          })
          .catch(error => console.error('Error updating cart:', error));
      } else if (eligibleGift && !isAlreadyInCart) {
        addEligibleGift(eligibleGift);
      }
      
    })
    .catch(error => console.error('Error fetching cart:', error));
}

function addEligibleGift(eligibleGift) {
  const eligibleVariantId = eligibleGift.getAttribute('freethresold-pId');

  console.log('Adding eligible free product:', eligibleVariantId);
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: eligibleVariantId,
        quantity: 1,
        properties: { _giftProduct: 'Gift Product' }
      }]
    })
  })
    .then(response => response.json())
    .then(() => {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    })
    .catch(error => console.error('Error adding free gift:', error));
}

// *** Cart drawer recommenadtion Add to cart - Deals of the day
 function quickAdd(){
    var customAddButtons = document.querySelectorAll(".drawercart-button");
    if(customAddButtons.length){
      customAddButtons.forEach(function(customAdd){
        customAdd.addEventListener('click',function(){
          // console.log("theme.js quick btn clicked.......");
          var productCard = customAdd.closest(".product-card-col");
          var quickViewBtn = productCard.querySelector(".quick-view-btn button");
          // console.log("quickViewBtn",quickViewBtn);
          quickViewBtn.click();
        });
      });
    }
  }

// Cart Drawer clear all cart functionality
 function clearAllCart(){
     var clearButton = document.querySelector(".cartclear-button");
     console.log("clearButton",clearButton);
     if(clearButton){
       clearButton.addEventListener('click', function () {
         console.log("clicked......");
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(response => response.json())
        .then(data => {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        })
        .catch(error => {
          console.error('Error clearing cart:', error);
        });
      });
     }
   }
  
// cart drawer - cart recommendation slider
  function cartRecommendationSlider(){
    const recommendationProducts = document.querySelector(".cart-drawer__recommendations .swiper");
      if(recommendationProducts){

         if (document.querySelector('.cart-drawer__recommendations')?.swiper) {
           document.querySelector('.cart-drawer__recommendations').swiper.destroy(true, true);
         }
        
        new Swiper(recommendationProducts, {
          loop:false,
          slidesPerView: 2.5,
          slideToClickedSlide: false,
          spaceBetween:12,
          autoplay: false,
          breakpoints: {       
            700: {
              slidesPerView: 2.8,
              spaceBetween:12
            }
          }
        });
      }
  }

// collection page custom filters https://prnt.sc/m-fjwjCXmMJC
 function customFilters(){
   console.log("custom filter code calls");
     //*** START collection page filter button refresh project without refresh 
    var filterTags = document.querySelectorAll(".collection__top-bar .filterTag");
    if(filterTags.length){
      filterTags.forEach(function(filtertag){
        var filterTagBtn = filtertag.querySelector("button");
        filterTagBtn.addEventListener('click',function(){
          console.log("filter btn clicked.....");
          filterTagBtn.classList.add('active');
          var filterTagVal = filterTagBtn.getAttribute("data-filtertag");
          var filterElements = document.querySelectorAll(".checkbox-container");
          filterElements.forEach(function(filterElem){
            var inputElem = filterElem.querySelector("input");
            var inputVal = inputElem.getAttribute("data-value");
            // console.log("Input Value",inputVal);
            if(filterTagVal == inputVal){
              inputElem.click();
            }
          });
        });
      });
    }

    var sortCustomFilters = document.querySelectorAll(".sortby-popup-filter li");
    if(sortCustomFilters.length){
      sortCustomFilters.forEach(function(sortCustomBtn){
        sortCustomBtn.addEventListener('click',function(){
          var sortCustomval = sortCustomBtn.getAttribute("data-sort");
          console.log("sortCustomval",sortCustomval);
          var filterElements = document.querySelectorAll(".checkbox-container");
          filterElements.forEach(function(filterElem){
            var inputElem = filterElem.querySelector("input");
            var inputVal = inputElem.getAttribute("data-value");
            console.log("Input Value",inputVal);
            if(sortCustomval == inputVal){
          //     console.log("value matched...");
              inputElem.click();
            }
          });
        });
      });
    }
    //*** END
 }

// Collection page Filter drawer mobile
document.addEventListener("facet:update", async (event) => {
  setTimeout(function(){
    var activeFilterElems = document.querySelectorAll(".filtervalues .checkbox-container input:checked");
      if(activeFilterElems){
        activeFilterElems.forEach(function(activeFilter){
          var activeValue = activeFilter.getAttribute("data-value");
          if(activeValue){
            console.log("Active Value",activeValue);
            var filterBtnElems = document.querySelectorAll(".collection__top-bar .filterTag");
              filterBtnElems.forEach(function (filterBtnElem) {
                var filterBtn = filterBtnElem.querySelector("button");;
                var btnval = filterBtn.getAttribute("data-filtertag")
                console.log("Btn Value",btnval);
                if (btnval === activeValue) {
                  console.log("matched.....");
                  filterBtn.classList.add("active");
                }else{
                  filterBtn.classList.remove("active");
                }
              });
          }
        });
      }

      var tabTitles = document.querySelectorAll("facet-drawer .tab_title");
      // console.log("tabTitles",tabTitles);
      if (tabTitles) {
        const accordions = document.querySelectorAll("facet-drawer .filter-accordian");
        accordions.forEach((accordion, index) => {
                if (index === 0) {
                    accordion.classList.add("active");
                }
        });
        
        tabTitles.forEach(function(tabTitle){
          tabTitle.addEventListener('click', function() {
            console.log("title",tabTitle);
            tabTitles.forEach(tabTitle => tabTitle.classList.remove("active"));
            tabTitle.classList.add("active");
            var tabLabel = tabTitle.getAttribute("data-label");
            accordions.forEach(accordion => accordion.classList.remove("active"));
            
            var dataAccordian = document.querySelector("facet-drawer .filter-accordian[data-content='" + tabLabel + "']");
            dataAccordian.classList.add('active');
            
            // Check if the dataAccordian has the open attribute
            if (!(dataAccordian.hasAttribute('open'))) {
              dataAccordian.querySelector("summary").click();
            }
          });
        });
      
        // Trigger the first tab click
        tabTitles[0]?.click();
      }
  },1000);
});

// product page kgs & lbs switch

function productInfo(){
    // *** START Product page kgs and labs switch  ***
      var sizeTypeElem = document.querySelector(".size_types_wrapper");
      // console.log("sizeTypeElem",sizeTypeElem);
      if (sizeTypeElem) {
        var SizeValues = sizeTypeElem.querySelectorAll(".size_label");
        if (SizeValues.length) {
          SizeValues.forEach((sizeVal) => {
            sizeVal.addEventListener('click', function () {
              SizeValues.forEach((elem) => {
                if (elem !== sizeVal) {
                  elem.classList.remove('active');
                }
              });
              sizeVal.classList.add('active'); 
              var selectedSize = sizeVal.getAttribute("data-value");
              var valueElems = document.querySelectorAll(".variant-picker__option-values .size-val");
              if(valueElems.length){
                valueElems.forEach((valueElem)=>{
                 var selectedValue = valueElem.getAttribute("data-value");
                  if(selectedSize != selectedValue){
                    valueElem.classList.add('hidden');
                  }else{
                    if(valueElem.classList.contains('hidden')){
                      valueElem.classList.remove("hidden");
                    }
                  }
                });
              }
            });
          });
        }
      }
    // *** END Product page kgs and labs switch  ***

    // *** START Product page variant base information in accordian 
      var currentinput = document.querySelector(".product-info__buy-buttons input[name='id']")?.value;
      if(currentinput != 'undefined')
      {
        var variantOtherInfoElems = document.querySelectorAll(".otherInformation-wrapper .variantDeatils_block");
        if(variantOtherInfoElems.length){
          variantOtherInfoElems.forEach((variantBlock)=>{
            variantBlock.classList.remove('hidden');
            var varinatBlockId = variantBlock.getAttribute("data-variantid");
            if(currentinput != varinatBlockId){
              variantBlock.classList.add('hidden');
            }
          });
        }
      }
    // *** END Product page variant base information in accordian 

    //*** START Product page show discount base and saving price in product media
    
      var discountPercentage = document.querySelector("on-sale-badge[data-discount]");
      // console.log("discountPercentage",discountPercentage);
      if(discountPercentage){
        var discount = discountPercentage.getAttribute("data-discount");
        var price = discountPercentage.getAttribute("data-price");
        var compare_price = discountPercentage.getAttribute("data-comapre-price");
        var difference = discountPercentage.getAttribute("saved_price_default");
        // console.log("discount >> ",discount);
  
        var discountElement = document.querySelector(".discountPercentage span");
        if (discountElement) {
        discountElement.textContent = discount;
        }
        var stickyBarElem = document.querySelector(".pdp-stickybar .stickybar-wrap");
        if (stickyBarElem) {
          // console.log("stickyBarElem:",stickyBarElem);
          stickyBarElem.querySelector(".discount-percentage span") && (stickyBarElem.querySelector(".discount-percentage span").textContent = discount);
          stickyBarElem.querySelector(".product-price") && (stickyBarElem.querySelector(".product-price").textContent = price);
          stickyBarElem.querySelector(".product-compare-price") && (stickyBarElem.querySelector(".product-compare-price").textContent = compare_price);
          stickyBarElem.querySelector(".updated_saved_value") && (stickyBarElem.querySelector(".updated_saved_value").textContent = difference);
          var cartBtnpriceElem = stickyBarElem.querySelector(".cart-btn .price-block");
          if(cartBtnpriceElem){
            cartBtnpriceElem.querySelector(".variant-price") && (cartBtnpriceElem.querySelector(".variant-price").textContent = price);
            cartBtnpriceElem.querySelector(".variant-compare-price") && (cartBtnpriceElem.querySelector(".variant-compare-price").textContent = compare_price);
          }
        }      
      }
    //*** END Product page show discount base and saving price in product media
     
    //*** START Product page main slider and thumbnail slider 
     let mainSlider, thumbnailSlider; // Declare Swiper instances globally

      function mainPDPSlider() {
          // Check if Swiper instance exists and destroy it
          if (document.querySelector('.main-slider')?.swiper) {
              document.querySelector('.main-slider').swiper.destroy(true, true);
          }
          if (document.querySelector('.thumbnail-slider')?.swiper) {
              document.querySelector('.thumbnail-slider').swiper.destroy(true, true);
          }

          mainSlider = new Swiper('.main-slider', {
              slidesPerView: 1,
              loop: false,
              spaceBetween: 0,
              pagination: {
                  el: ".cst-product-slider-wrapper .swiper-pagination",
                  clickable: true,
              },
              breakpoints: {
                  0: {
                      slidesPerView: 1.2,
                      spaceBetween: 12
                  },
                  700: {
                      slidesPerView: 1
                  }
              }
          });
      
          thumbnailSlider = new Swiper('.thumbnail-slider', {
              direction: 'vertical',
              loop: false,
              slidesPerView: 6,
              spaceBetween: 0,
              navigation: {
                  nextEl: '.thumbnail-next',
                  prevEl: '.thumbnail-prev',
              },
              slideToClickedSlide: true,
          });
      
          // Sync thumbnail slider with main slider
          thumbnailSlider.on('click', (swiper) => {
              const clickedIndex = swiper.clickedIndex;
              mainSlider.slideTo(clickedIndex);
              updateThumbnailActiveClass(thumbnailSlider, clickedIndex);
          });
      
          mainSlider.on('slideChange', () => {
              const activeIndex = mainSlider.activeIndex;
              thumbnailSlider.slideTo(activeIndex);
              updateThumbnailActiveClass(thumbnailSlider, activeIndex);
          });
      
          function updateThumbnailActiveClass(swiper, activeIndex) {
              swiper.slides.forEach((slide, index) => {
                  slide.classList.toggle('swiper-slide-active', index === activeIndex);
              });
          }
          
      }
      
      // Product page show and hide images on varinat select and set slider

      var variantPickerElem = document.querySelector(".product-info__variant-picker");
      if (variantPickerElem) {
          var variantSku = variantPickerElem.getAttribute("data-variantsku");
          var variantPrefix = variantSku.slice(0, 7); // First 7 characters
          const elements = document.querySelectorAll("[data-imagealt]");
          let matchFound = false;
      
          elements.forEach((element, index) => {
              const dataValue = element.getAttribute("data-imagealt").replace(/\n/g, '').split(" ");
              const prefixMatch = dataValue.some(val => val.startsWith(variantPrefix));

              if (dataValue.includes(variantSku) || dataValue.includes("viewall")) {
                  matchFound = true;
                  element.classList.remove("non-swiper-slide", "hidden");
                  element.classList.add("swiper-slide");
              } else {
                  element.classList.add("non-swiper-slide", "hidden");
                  element.classList.remove("swiper-slide");
              }
          });
      
          // If no match is found, show all elements as swiper slides
          if (!matchFound) {
              elements.forEach(element => {
                  element.classList.remove("non-swiper-slide", "hidden");
                  element.classList.add("swiper-slide");
              });
          }
  
          setTimeout(function(){
              mainPDPSlider();
          },50);
      }
      
    //*** END Product page main slider and thumbnail slider 
    
    //product page - on custom button click theme's deafult button click
        var customBuyButton =  document.querySelector(".quantity_buyButton_wrapper .buyButton button");
        // console.log("customBuyButton",customBuyButton);
        if(customBuyButton){
          customBuyButton.addEventListener('click',function(){
            // console.log("custom button clicked...");
           // document.querySelector(".product-info__buy-buttons button").click();
            document.querySelector('#pdpStickyCart button').click();
          });
        }

    // // product page variant swiper slider start
    //     const sliders = document.querySelectorAll('.variant-options1');
    //     sliders.forEach((slider) => {
    //       new Swiper(slider, {
    //         loop: false,
    //         slidesPerView: 'auto',
    //         spaceBetween: 0,
    //         autoplay: false,
    //       });
    //     });
    // product page variant swiper slider end


    //Product page varinats scroll
      function applyStyles() {
          let optionValues = document.querySelectorAll(".variant-picker__option-values");
          if (optionValues.length) {
              optionValues.forEach(optionValue => {
                  optionValue.style.flexWrap = 'nowrap';
              });
          }
      }
      
      // Observe DOM changes and apply styles when elements appear
      let observer = new MutationObserver(applyStyles);
      observer.observe(document.body, { childList: true, subtree: true });
      
      // Run once in case elements are already present
      setTimeout(function(){
        applyStyles();  
      },500);
      

  // Product page if variant disabled then trigger click on available variants
    // var variantOption = document.querySelector(".variant-picker__option.flavour");
    // if(variantOption){
    //   //check that checked input is disabled....
    //   var checkedinput = variantOption.querySelector("input:checked");
    //   if (checkedinput.classList.contains("is-disabled")) {
    //     var firstValidInput = variantOption.querySelector( ".variant_option_block input:not(.is-disabled)" );
    //     if (firstValidInput) {
    //       firstValidInput.click(); 
    //     }
    //   }
    // }

    
   
}



function disabledOption1(newVariant){
  var option2 = newVariant.option2;
  if(option2 != null){
    console.log("Option2",option2);



  const productRerenders = document.querySelectorAll('product-rerender');
  const variantJSONScript = document.getElementById('currentProductVariantJSON');

  productRerenders.forEach(rerender => {
    const pid = rerender.getAttribute('data-pid');

    if (pid === "9172872790247") { // 👉 Check if pid matches "X"
      const buttonText = document.querySelector('.buy-buttons .buybutton-text');
      if (buttonText) {
        if (variantJSONScript) {
          const variantData = JSON.parse(variantJSONScript.textContent);
    
          if (variantData.available === true) {
              //buttonText.textContent = "Pre-Order"; // 👉 Change the text
          }
          else{
            buttonText.textContent = "SOLD OUT"; // 👉 Change the text
          }
        } 
      }


      /* const atcContainer = document.getElementById('custom-add-to-cart-pdp');
      if (atcContainer) {
        const firstSpan = atcContainer.querySelector('span');
         if (firstSpan) {
          setTimeout(
          firstSpan.textContent = 'PRE-ORDER'
          ,250);// Change the text here
        }
      }*/
    }
  });
    
    
    var variantJson = JSON.parse(document.querySelector("variant-picker").getAttribute("data-variant"));
     if (Array.isArray(variantJson)) {
      let matchingVariants = variantJson.filter(variant => variant.option2 === option2);
      let option1Values = matchingVariants.map(variant => variant.option1);
      // console.log("option1Values",option1Values);

      // Select all labels with a data-value attribute
      document.querySelectorAll('.variant-picker__option.size .block-swatch').forEach(label => {
        label.classList.remove('is-disabled');
          const value = label.getAttribute('data-value');
          
          // If the value is NOT in filteredValues, add 'disabled' class
          if (!option1Values.includes(value)) {
            label.classList.add('is-disabled');
          }
      });
  } else {
      console.error("variantJson is not an array");
      }
  }

   const itemsReload = document.querySelectorAll('.variant-picker .variant_option_block[data-order="1"]');
   if (itemsReload.length > 0) {
      itemsReload.forEach(item => {
        item.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      });
    }
}
 //*** START product page you may also like slider for mobile
      function executeOnSmallScreen() {
        if (window.innerWidth < 700) {
          new Swiper('.recom-slider', {
            loop: false,
            slidesPerView: 4,
            spaceBetween: 10,
            autoplay: false,      
            breakpoints: {
              0: {
                slidesPerView: 2.3,
                spaceBetween: 12,
              },
              480: {
                slidesPerView: 3.3,
                spaceBetween: 30,
              },
              990: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
            },
          });
        }
      }


// RecentlyViewd slider
function recentlyViewed(){
    const recentlyViewed = document.querySelector(".recently-viewed");
      const slider = recentlyViewed.querySelector(".productlistslider");
        new Swiper(slider, {
          loop: false,
          slidesPerView: 4,
          spaceBetween: 10,
          autoplay: false,
           navigation: {
            nextEl: recentlyViewed.querySelector('.rightarrow-sliderbutton'), 
            prevEl: recentlyViewed.querySelector('.leftarrow-sliderbutton'),  
          },
          pagination: {
            el: slider.querySelector('.swiper-pagination'), // Pagination specific to this slider
            clickable: true,
          },
          breakpoints: {
            0: {
              slidesPerView: 2.3,
              spaceBetween: 12,
            },
            480: {
              slidesPerView: 3.3,
              spaceBetween: 30,
            },
            990: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
          },
        });  
}

// quickview pop add to cart
function quickViewPopupAdd(customBuyButton) {
  if (!customBuyButton) return;

  if (!customBuyButton.dataset.listenerAdded) {
    customBuyButton.dataset.listenerAdded = "true"; // Mark as added

    customBuyButton.addEventListener("click", function () {
      var variantID = this.getAttribute("variant-id");
      var loadingSpan = this.querySelector("span.button__loading"); // Get the span element inside the button

      if (loadingSpan) {
        loadingSpan.classList.add("active"); // Add loading class
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantID,
          quantity: 1,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.dispatchEvent(new CustomEvent("gnc:variant:add",{
            detail: {
                    items: data
                  }
          }));
          //console.log("data",data);
          let cartButton = document.querySelector(
            ".header__icon-list [aria-controls='cart-drawer']"
          );

          if (cartButton) {
            cartButton.click();
          }
        })
        .catch((error) => console.error("Error adding products:", error))
        .finally(() => {
          if (loadingSpan) {
            loadingSpan.classList.remove("active"); // Remove loading class
          }
        });
    });
  }
}
// **** functions available in theme.js file ****//

function initCartObserver() {
    const targetNode = document.querySelector("#cart-drawer");
    if (!targetNode) {
        setTimeout(initCartObserver, 300);
        return;
    }
    const observer = new MutationObserver(() => {
        const cartElement = document.getElementById("cart-data");
        const itemCount = cartElement?.dataset.itemCount;
        const cartCount = document.querySelector("cart-count");
        if (cartCount && itemCount !== undefined) {
            cartCount.textContent = itemCount;
        } else {
        }
    });
    const config = { attributes: true, childList: true, characterData: true, subtree: true };
    observer.observe(targetNode, config);
}
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartObserver);
} else {
    initCartObserver();
}


function applyUnitState() {
  const checkbox = document.getElementById('checkbox-lbskgs');
  const variantPicker = document.querySelector("variant-picker.variant-picker");

  if (!checkbox || !variantPicker) return;

  const units = localStorage.getItem('units');
  const isKgs = units === 'kgs';
  //console.log("isKgs",units,isKgs);
  checkbox.checked = isKgs;
  if (isKgs)
    setTimeout(variantPicker.classList.add('unit-kgs'), 300);
  else
    setTimeout(variantPicker.classList.remove('unit-kgs'), 300);
  
  //console.log("applyUnitState", units);
  unitSwitcher();
}

async function unitSwitcher() {
  const toggle = document.getElementById('checkbox-lbskgs');

  if (toggle) {
    toggle.addEventListener('change', function () {
      const variantPicker = this.closest('variant-picker.variant-picker');
      const units = this.checked ? 'kgs' : 'lbs';

      variantPicker?.classList.toggle('unit-kgs', this.checked);
      localStorage.setItem('units', units);
      console.log("units", units);
    });
  }
}

function initUnitLogic() {
  const variantPicker = document.querySelector("variant-picker.variant-picker");

  if (!variantPicker) {
    setTimeout(initUnitLogic, 300); // Retry
    return;
  }

  // Set state on load
  applyUnitState();

  // Setup checkbox logic
  unitSwitcher();
}

// Run on page load
if (document.readyState === "loading") {
  document.addEventListener('DOMContentLoaded', initUnitLogic);
} else {
  initUnitLogic();
}

// Optional: Re-apply unit state if variant changes affect layout
document.addEventListener('variant:change', applyUnitState);

